// extracted by mini-css-extract-plugin
export default {"container":"styles_container__t12n5","version-label":"styles_version-label__Yyu0n","actions-wrapper":"styles_actions-wrapper__rJDlp"};